import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function PromptEngineerOptimizedDraft({
    instructionName,
    originalInstructions,
    optimizedInstructions,
    hasOptimizedVersion,
    activeVersion,
    onChangeActiveVersion,
    onChangeOriginalInstructions,
    onChangeOptimizedInstructions,
    onBack,
    onSave,
    isSaving
}) {
    const activeText = activeVersion === 'optimized' && hasOptimizedVersion
        ? optimizedInstructions
        : originalInstructions;

    const handleTextChange = (event) => {
        const nextValue = event.target.value;
        if (activeVersion === 'optimized' && hasOptimizedVersion) {
            onChangeOptimizedInstructions(nextValue);
            return;
        }
        onChangeOriginalInstructions(nextValue);
    };

    return (
        <Card elevation={2}>
            <CardContent>
                <Stack spacing={2}>
                    <Typography variant="h6" align="center">Review Your Final Instructions</Typography>
                    <Stack spacing={1.25} alignItems="center">
                        <Chip
                            label="Final review before saving your instructions"
                            variant="outlined"
                            color="primary"
                            sx={{
                                bgcolor: 'common.white',
                                maxWidth: '100%',
                                '& .MuiChip-label': {
                                    fontSize: '0.95rem',
                                    py: 1,
                                    px: 1.5,
                                    whiteSpace: 'normal',
                                    textAlign: 'center',
                                    lineHeight: 1.35
                                }
                            }}
                        />
                        <Chip
                            label={(
                                <>
                                    Instruction name:{' '}
                                    <Box component="span" sx={{ fontWeight: 700 }}>
                                        {instructionName}
                                    </Box>
                                </>
                            )}
                            variant="outlined"
                            color="primary"
                            sx={{
                                bgcolor: 'common.white',
                                maxWidth: '100%',
                                '& .MuiChip-label': {
                                    fontSize: '0.95rem',
                                    py: 1,
                                    px: 1.5,
                                    whiteSpace: 'normal',
                                    textAlign: 'center',
                                    lineHeight: 1.35
                                }
                            }}
                        />
                    </Stack>
                    {hasOptimizedVersion && (
                        <Box>
                            <Tabs
                                value={activeVersion}
                                onChange={(_, value) => onChangeActiveVersion(value)}
                                variant="fullWidth"
                            >
                                <Tab value="optimized" label="Optimized Draft" />
                                <Tab value="original" label="Original Draft" />
                            </Tabs>
                        </Box>
                    )}
                    <TextField
                        label={activeVersion === 'optimized' && hasOptimizedVersion ? 'Optimized Instructions' : 'Final Instructions'}
                        value={activeText}
                        onChange={handleTextChange}
                        minRows={22}
                        multiline
                        fullWidth
                    />
                    <Stack direction="row" spacing={2}>
                        <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={onBack}>
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            onClick={onSave}
                            disabled={isSaving || !instructionName.trim() || !activeText.trim()}
                        >
                            Save Instruction
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
